import {useAMap} from "../mixins/amap"
import autocomplete from "../lib/autocomplete"

export default class extends ApplicationController {
    static targets = ["user"]

    connect() {
        useAMap(this)
        this.initMap()

        this.userTarget.autocomplete = "off"
        this.selectedUser = null

        this.initAutoComplete()
    }

    initMap() {
        this.loadMap("map", 20, (map) => {
            this.map = map
            this.map.setFeatures(['bg', 'point'])
            this.map.on('rightclick', this.onMapRightClick)

            this.initAMapContextMenu()
            this.fetchTrackPaths()
        })
    }

    initAMapContextMenu() {
        this.mapContextMenu = new AMap.ContextMenu()

        this.mapContextMenu.addItem("显示全部轨迹", this.onAllTracksDisplay)
        this.setPhotoMenuItem(true)

    }

    initAutoComplete() {
        autocomplete({
            minLength: 1,
            preventSubmit: true,
            input: this.userTarget,
            attachedClassName: "all-driving-tracks",
            className: "auto-complete",
            emptyMsg: "该用户没有找到",
            debounceWaitMs: 400,
            fetch: (text, update) => {
                let url = `/offsite_users.json?user=${text}`
                fetch(url)
                    .then(response => response.json())
                    .then(data => {
                        let items = data.map((record) => {
                            return {phone: record.phone}
                        })

                        update(items)
                    })
            },
            render: (item, currentValue) => {
                let div = document.createElement('div')
                div.innerHTML = `${item.phone}`
                return div
            },
            onSelect: (item) => {
                this.userTarget.value = item.phone
                this.selectedUser = item.phone

                this.fetchTrackPaths()
            }
        })
    }

    makeTrackPathsOnMap(paths) {
        for (let path of paths) {
            let pathOverlay = this.makePathOnMap(this.map, path.path)

            pathOverlay.setOptions({cursor: 'pointer'})
            pathOverlay.setExtData({id: path.id, user: path.user})

            pathOverlay.on('dblclick', this.onTrackPathDblclick)
            pathOverlay.on('rightclick', this.onTrackPathRightClick)
        }

        this.map.setFitView(null, false, [0, 0, 0, 0])
    }

    async fetchTrackPaths() {
        let fetchData = async (page) => {
            let url = null

            if (this.selectedUser) {
                url = `/driving_tracks.json?page=${page}&user=${this.selectedUser}`
            }
            else {
                url = `/driving_tracks.json?page=${page}`
            }

            let response = await fetch(url)
            let trackData = await response.json()

            this.makeTrackPathsOnMap(trackData.paths)

            return trackData.page_count
        }

        this.map.setDefaultCursor("wait")

        // Clear all overlays
        let overlays = this.map.getAllOverlays()
        this.map.remove(overlays)

        // Get first page for get page count
        let pageCount = await fetchData(1)

        for (let page = 2; page <= pageCount; page++) {
            await fetchData(page)
        }

        this.map.setDefaultCursor("default")
    }

    async fetchPhotos() {
        let fetchData = async (page) => {
            let url = `/driving_photos.json?page=${page}`

            let response = await fetch(url)
            let photoData = await response.json()

            for (let photo of photoData.photos) {
                let marker = this.makeMarkerOnMap(this.map, {x: photo.x, y: photo.y})
                
                marker.setExtData(photo.id)
                marker.on('dblclick', this.onPhotoDblclick)
            }

            return photoData.page_count
        }

        let pageCount = await fetchData(1)

        for (let page = 2; page <= pageCount; page++) {
            await fetchData(page)
        }
    }

    setPhotoMenuItem(isShowPhotos) {
        const displayText = "显示抓拍照片"
        const hideText = "隐藏抓拍照片"

        if (isShowPhotos) {
            this.mapContextMenu.addItem(displayText, this.onPhotosDisplay)
            this.mapContextMenu.removeItem(hideText, this.onPhotosHide)
        }
        else {
            this.mapContextMenu.removeItem(displayText, this.onPhotosDisplay)
            this.mapContextMenu.addItem(hideText, this.onPhotosHide)
        }
    }

    onAllTracksDisplay = (e) => {
        this.userTarget.value = ""
        this.selectedUser = null
        this.fetchTrackPaths()
    }

    onPhotosDisplay = (e) => {
        this.fetchPhotos().then(() => {
            this.setPhotoMenuItem(false)
        })
    }

    onPhotosHide = (e) => {
        let overlays = this.map.getAllOverlays('marker')
        this.map.remove(overlays)

        this.setPhotoMenuItem(true)
    }

    onMapRightClick = (e) => {
        this.mapContextMenu.open(this.map, e.lnglat)
    }

    onTrackPathDblclick = (e) => {
        let id = e.target.getExtData().id
        let url = `/driving_tracks/${id}`

        window.open(url, '_blank')
    }

    onTrackPathRightClick = (e) => {
        let user = e.target.getExtData().user

        let trackPathContextMenu = new AMap.ContextMenu()

        trackPathContextMenu.addItem(`${user}`, this.onUserTracksDisplay.bind(this, user))
        trackPathContextMenu.open(this.map, e.lnglat)
    }

    onUserTracksDisplay(user, e) {
        this.selectedUser = user
        this.fetchTrackPaths()
    }

    onPhotoDblclick = (e) => {
        let id = e.target.getExtData()
        let url = `/driving_photos/${id}`

        window.open(url, '_blank')
    }
}